import './bariPreAddGeneralPractitioner/register';
import './bariPreAddToMdo/register';
import './bariPreCaroAccountNotActivatedNotification/register';
import './bariPreCaroInactivityPoliReport/register';
import './bariPreCloseProcessPrematurely/register';
import './bariPreDietPlanAppointment/register';
import './bariPreDietScreening/register';
import './bariPreExternalReferral/register';
import './bariPreGroupSession/register';
import './bariPreMdoInterimReport/register';
import './bariPreMdoReport/register';
import './bariPreMedConsultAssessment/register';
import './bariPreMedConsultExamResults/register';
import './bariPreMedConsultPlanAppointment/register';
import './bariPreMedConsultReport/register';
import './bariPreNurseSpecialistMedScreeningReport/register';
import './bariPrePsychQuestionnaire/register';
import './bariPrePsychScreening/register';
import './bariPreReferral/register';
import './bariPreResumeMdo/register';
import './bariPreResumeMdoInterim/register';
import './bariPreSecretarialAssistentMedScreeningReport/register';
